var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    {
      attrs: {
        href: "https://play.google.com/store/apps/details?id=com.sucasuc.empleatapp",
      },
    },
    [
      _c("img", {
        attrs: {
          alt: "Get it on Google Play",
          height: _vm.height,
          src: require("@/assets/google-play-badge.svg"),
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }